// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__hoG5m","content":"Footer_content__Gokyr","logo":"Footer_logo__4iY9S","navLinks":"Footer_navLinks__LnGYT"};